import axiosInstance from "./axiosInstance";

const getAllPointsHistory = async ({ pageParam = 1 }) => {
  const accessToken = localStorage.getItem("accessTokenGC");
  try {
    const { data } = await axiosInstance.get(
      `/api/points-history?page=${pageParam}&limit=10`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      },
    );
    return {
      pointsHistory: data.pointsHistory,
      nextPage: pageParam + 1,
      totalPages: data.pagination.totalPages,
    };
  } catch (error) {
    throw new Error("Error fetching points history.");
  }
};

export default getAllPointsHistory;
